import { i18n, inject, observer, React, Route, RouteComponentProps } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { HandoverURLTestOverview } from "./HandoverURLTestOverview";
import { HandoverURLTestRoutes } from "./HandoverURLTestRoutes";


type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class HandoverURLTestContainer extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    async componentDidMount() {
        pushRoute(HandoverURLTestRoutes.ROOT);
        georgeWebHeaderStore.configure({
            title: "Handover URL Test",
        });

    }

    render() {
        document.title = "Handover URL Test";
        return (
            <div>
                <Route exact path={HandoverURLTestRoutes.ROOT} component={HandoverURLTestOverview} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/handoverURLTest/HandoverURLTestContainer.tsx